import { Journey, KnowledgeDoc } from '../types';

export const SYSTEM_TEXTBOOK_DOCS: KnowledgeDoc[] = [
  {
    id: 'system-isc-reading-list',
    userId: 'system',
    title: 'ISC Reading List & Major Reports',
    isSystem: true,
    tags: ['Policy', 'Reports', 'Ethics'],
    content: `
      MAJOR REPORTS & GUIDANCE:
      1. GMC GOOD MEDICAL PRACTICE: The core ethical standard for UK doctors.
      2. THE FRANCIS INQUIRY: Failing at Mid Staffordshire. Key takeaway: "Duty of Candour" (being open when things go wrong).
      3. GIRFT (Getting It Right First Time): National programme to reduce variation and improve clinical outcomes through benchmarking.
      4. OCKENDEN REPORT: Focus on maternity safety, teamwork, and escalation of concerns.
      5. MENTAL CAPACITY ACT (MCA) 2005: Statutory framework for decisions on behalf of those who lack capacity.
      6. MONTGOMERY VS LANARKSHIRE (2015): Replaced Bolam for consent. Doctors must disclose "Material Risks" that a reasonable person would want to know.
    `
  },
  {
    id: 'system-isc-frameworks',
    userId: 'system',
    title: 'ISC Medical Interviews - Core Frameworks',
    isSystem: true,
    tags: ['Core Frameworks', 'Ethics'],
    content: `
      CORE FRAMEWORKS:
      1. CAMP (Bio): Clinical, Academic, Management, Personal.
      2. STAR (Competencies): Situation, Task, Action, Result/Reflect.
      3. SPIES (Dilemmas): Seek Info, Patient Safety, Initiative, Escalate, Support.
      4. CARE (Governance): Clinical Effectiveness, Audit, Risk Management, Education.
    `
  }
];

export const SEED_JOURNEYS: Journey[] = [];